<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title"><strong>ALTERAR VALORES</strong></h3>
  </div>

  <form
    [formGroup]="alterarValorForm"
    class="forms modal-alterar-valor"
    (ngSubmit)="save()"
  >
    <div class="modal-body">
      <div class="inputs">
        <h4 class="modal-alterar-valor-label" for="valorFinanciamento">
          Valor solicitado
        </h4>
        <input
          class="form-control"
          type="text"
          placeholder="R$ 00.000,00"
          maxlength="17"
          minlength="3"
          appShowErrorMessages
          formControlName="valorFinanciamento"
          name="valorFinanciamento"
          mask-money
          [prefix]="'R$'"
          appMoedaValidator
          valorMinimoMessage="Valor mínimo permitido R$"
          appOnlyNumberRestrictive
          [valorMinimo]="this.parametroRendaProduto.valorSolicitadoMinimo"
          [valorMaximo]="this.parametroRendaProduto.valorSolicitadoMaximo"
        />
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="bt-back btn btn-border-orange"
        (click)="close()"
      >
        Fechar
      </button>

      <button
        type="submit"
        class="bt-go btn btn-full-orange"
        [disabled]="!alterarValorForm.valid"
      >
        Salvar
      </button>
    </div>
  </form>
</div>
